import React from "react";
import PropTypes from "prop-types";
import { Button as CustomButton, Image } from "hesus-ui-kit";
import "./Button.scss";

const Button = (props) => {
  const { name, btnStyle, iconStyle, disabled, icon, onClick } = props;

  return (
    <CustomButton
      className={btnStyle}
      disabled={disabled}
      onClick={onClick}
      type="button"
      styles={{
        padding: "6px",
        color: "white",
        background: "#1BACE4",
        border: "1px solid #1BACE4",
        marginRight: "0.32rem",
        "&:hover": {
          backgroundColor: "#1589b6",
        },
      }}
    >
      {icon && (
        <Image
          src={icon}
          className={iconStyle}
          alt="Button icon"
          styles={{ width: "auto" }}
        />
      )}
      {name}
    </CustomButton>
  );
};

Button.propTypes = {
  disabled: PropTypes.bool,
  btnStyle: PropTypes.string,
  icon: PropTypes.string,
  name: PropTypes.string.isRequired,
  iconStyle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

Button.defaultProps = {
  btnStyle: "",
  icon: "",
  disabled: false,
};

export default Button;
